<template>
  <b-carousel
    :interval="interval"
    controls
    @sliding-end="$emit('sliding-end')"
    :id="cId"
    ref="carouselWrapper"
    v-model="current"
    :indicators="indicators"
    :background="back"
    :style="cStyle"
    :class="cClass"

  >
    <slot></slot>
  </b-carousel>
</template>

<script>
export default {
  name: "CCarousel",
  props:{
    interval:{
      type:Number,
      default:0,
    },
    indicators:{
      type:Boolean,
      default:true,
    },
    cId:{
      type:String,
      default: "",
    },
    cRef:{
      type:String,
      default: "",
    },
    value:{
      type:Number,
      default:0,
    },
    cStyle:{
      type:String,
      default: "",
    },
    back:{
      type:String,
      default: "",
    },
    cClass:{
      type:String,
      default: "",
    },
  },
  data(){
    return {
      offset:0,
      current:0,
    }
  },
  methods:{
    onMouseEnter(){
      this.$refs.carouselWrapper.$el.querySelector('.carousel-control-prev').focus();
    },
    onDown(e){
      this.offset = e.offsetX;
      e.preventDefault();
    },
    onUp(e){
      e.preventDefault();
      if ( this.offset > e.offsetX){ // left
        this.$refs.carouselWrapper.prev();
      }else if ( this.offset < e.offsetX){
        this.$refs.carouselWrapper.next();
      }
    },
  },
  watch:{
    current(){
        this.$emit('input', this.current);
    }
  },
  mounted() {
    if(this.value != undefined)
      this.current = this.value;
    var self = this;
    setTimeout(()=>{
      self.$refs.carouselWrapper.$el.querySelector('.carousel-inner').onmousedown=self.onDown;
      self.$refs.carouselWrapper.$el.querySelector('.carousel-inner').onmouseup=self.onUp;
      self.$refs.carouselWrapper.$el.querySelector('.carousel-inner').onmouseover=self.onMouseEnter;
    },200);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/controls/CCarousel.vue